var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "ruleForm",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("消息标题"),
      prop: "title"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("消息标题"),
      allowClear: ""
    },
    model: {
      value: _vm.form.title,
      callback: function ($$v) {
        _vm.$set(_vm.form, "title", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.title"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("消息内容"),
      prop: "content"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption,
      placeholder: _vm.$t("请输入") + _vm.$t("消息内容")
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上传文件"),
      prop: "fileList"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.form.fileList,
      "before-upload": _vm.beforeUpload,
      accept: ".doc,.docx,.xlsx,.xls,.mp4,.jpg,.pdf,.jpeg,.png",
      data: {
        module: "fileMessages"
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: e => _vm.handleChange(e),
      preview: _vm.previewFile
    }
  }, [_c("div", [_c("a-button", {
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      type: "link",
      block: ""
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(_vm._s(_vm.$t("点击上传文件")))], 1)], 1)])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("接收对象"),
      prop: "usersId"
    }
  }, [_c("el-cascader", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("系统内账号"),
      options: _vm.computedAccountTreeData,
      props: _vm.props,
      "popper-class": "scene_message",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeAccount
    },
    model: {
      value: _vm.form.usersId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "usersId", $$v);
      },
      expression: "form.usersId"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发送时间"),
      prop: "sendTime",
      required: ""
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.timechange
    },
    model: {
      value: _vm.form.sendTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sendTime", $$v);
      },
      expression: "form.sendTime"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "SEND_NOW"
    }
  }, [_vm._v(_vm._s(_vm.$t("立即发送")))]), _c("a-radio", {
    attrs: {
      value: "TIMED_SEND"
    }
  }, [_vm._v(_vm._s(_vm.$t("定时发送")))])], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("消息将于")) + " "), _c("a-date-picker", {
    staticStyle: {
      width: "200px",
      "margin-left": "10px"
    },
    attrs: {
      format: "YYYY-MM-DD",
      placeholder: _vm.$t("选择日期"),
      "value-format": "YYYY-MM-DD",
      disabled: _vm.form.sendTime !== "TIMED_SEND"
    },
    on: {
      change: _vm.changeTimeValidate
    },
    model: {
      value: _vm.form.sendDateTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sendDateTime", $$v);
      },
      expression: "form.sendDateTime"
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "80px",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      min: 0,
      max: 23,
      disabled: _vm.form.sendTime !== "TIMED_SEND",
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      change: _vm.changeTimeValidate
    },
    model: {
      value: _vm.form.sendTimeHour,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sendTimeHour", $$v);
      },
      expression: "form.sendTimeHour"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("时")) + " "), _c("a-input-number", {
    staticStyle: {
      width: "80px",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      min: 0,
      max: 59,
      disabled: _vm.form.sendTime !== "TIMED_SEND",
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      change: _vm.changeTimeValidate
    },
    model: {
      value: _vm.form.sendMinuteuHour,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sendMinuteuHour", $$v);
      },
      expression: "form.sendMinuteuHour"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("分")) + _vm._s(_vm.$t("发出")) + " ")], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("展现形式"),
      prop: "displayForm"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.displayForm,
      callback: function ($$v) {
        _vm.$set(_vm.form, "displayForm", $$v);
      },
      expression: "form.displayForm"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "NOTICE"
    }
  }, [_vm._v(_vm._s(_vm.$t("仅通知")))]), _c("a-radio", {
    attrs: {
      value: "FORCED_READING"
    }
  }, [_vm._v(_vm._s(_vm.$t("强制阅读弹窗")))])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("发送消息")))])], 1), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["mp4"],
      fileList: _vm.form.fileList,
      show: _vm.fileType,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: _vm.cancelPre
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };